<template>
  <div class="serviceStatsContainer">
    <div class="header">
      <Header title="服务统计" />
      <a-tooltip
        :trigger="trigger"
        :placement="placement"
        overlayClassName="prompt"
        :getPopupContainer="getPopupContainer"
      >
        <template #title>
          <span>{{ data.prompt }}</span>
        </template>
        <img v-if="isShowTooltip" class="question" :src="question" alt="" />
      </a-tooltip>
    </div>
    <div class="serviceStats">
      <div class="tatItem" v-for="(item, index) in list" :key="index">
        <div>
          <img v-if="data?.iconList?.[index]" class="icon" :src="data?.iconList?.[index]" />
          <div v-else class="emptyIcon"></div>
        </div>
        <div class="right">
          <div class="label">{{ item.label }}</div>
          <div class="countWrapper">
            <div class="count">{{ data?.[item.key] || 0 }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import Header from '../Header'
import question from '@/assets/img/work-place/question.png'

defineProps({
  list: {
    type: Array,
    default: () => []
  },
  data: {
    type: Object,
    default: () => {}
  },
  trigger: {
    type: String,
    default: 'hover'
  },
  placement: {
    type: String,
    default: 'right'
  },
  isShowTooltip: {
    type: Boolean,
    default: false
  }
})
const getPopupContainer = trigger => {
  return trigger.parentNode
}
</script>

<style scoped lang="scss">
.serviceStatsContainer {
  .header {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eff4f9;
    display: flex;
    align-items: center;

    .question {
      width: 14px;
      height: 14px;
      margin-left: 6px;
    }

    ::v-deep(.prompt) {
      .ant-tooltip-inner {
        border-radius: 4px;
      }
    }
  }

  .serviceStats {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tatItem {
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;
      margin-right: 48px;

      .icon,
      .emptyIcon {
        width: 48px;
        height: 48px;
        margin-right: 16px;
        border-radius: 8px;
        background: #f5f7fa;
        border: none;
      }

      .right {
        height: 48px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .label {
          color: #1c1c1c;
          font-size: 14px;
          font-weight: 400;
        }

        .countWrapper {
          display: flex;
          align-items: flex-end;
          .count {
            margin-right: 6px;
            color: #1c1c1c;
            font-size: 24px;
            font-weight: 700;
            line-height: 24px;
          }

          .unit {
            color: #1c1c1c;
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
    }
  }
}
</style>
